import { StringUtils } from './siteUtils'

export const DEFAULT_INSTALLATION_MODE = 'integrated'

export const LandingType = {
  Unassigned: 'unassigned',
  Assigned: 'assigned',
  DigitalRetail: 'dr',
  OEM: 'oem'
}

export const LANDING_SELECTORS = {
  LANDING_ASSIGNED_COMPONENT: 'landing-assigned',
  LANDING_UNASSIGNED_COMPONENT: 'landing-unassigned',
  MAIN_BACKGROUND: 'landing-background',
  MAIN_HEADING: 'h1[data-testid="ci-heading"]',
  DYNAMIC_ENTRY: 'ico-dynamic-entry-hydrator',
  STEP_BY_STEP: 'landing-step-by-step',
  STEP_BUTTON: '#step-by-step-start-my-offer',
  FAQ_SECTION: '#landing-faq',
  CONTACT_SECTION: 'landing-contact',
  LEGAL_SECTION: 'landing-legal'
}

export const LANDING_LABEL = {
  MainBackground: 'Main Background',
  Heading: 'Main Heading',
  DynamicEntryForm: 'Dynamic Entry Form',
  StepBystepSection: 'Step-by-Step Section',
  StepButton: 'Step Button (END OF STEPS)',
  FAQSection: 'FAQ Section',
  ContactSection: 'Contact Section',
  LegalSection: 'Legal Section'
}

export const formatVehicleParam = param => {
  return StringUtils.getStringValue(param)?.replaceAll('+', ' ')
}

export const getElementInfo = (selector, label) => {
  const landingComponent = document.querySelector(LANDING_SELECTORS.LANDING_COMPONENT)
  if (!landingComponent) return null

  const element = landingComponent.querySelector(selector)
  if (!element) return null

  const rect = element.getBoundingClientRect()
  const top = window.pageYOffset + rect.top
  const bottom = top + rect.height

  return {
    element,
    label,
    selector,
    top: Math.round(top),
    bottom: Math.round(bottom),
    height: Math.round(rect.height),
    viewportTop: Math.round(rect.top)
  }
}

export const calculateDynamicHeight = (targetSelector = LANDING_SELECTORS.STEP_BUTTON, fallbackHeight = 2000) => {
  try {
    const sections = [
      getElementInfo(LANDING_SELECTORS.MAIN_BACKGROUND, LANDING_LABEL.MainBackground),
      getElementInfo(LANDING_SELECTORS.MAIN_HEADING, LANDING_LABEL.Heading),
      getElementInfo(LANDING_SELECTORS.DYNAMIC_ENTRY, LANDING_LABEL.DynamicEntryForm),
      getElementInfo(LANDING_SELECTORS.STEP_BY_STEP, LANDING_LABEL.StepBystepSection),
      getElementInfo(LANDING_SELECTORS.STEP_BUTTON, LANDING_LABEL.StepButton),
      getElementInfo(LANDING_SELECTORS.FAQ_SECTION, LANDING_LABEL.FAQSection),
      getElementInfo(LANDING_SELECTORS.CONTACT_SECTION, LANDING_LABEL.ContactSection),
      getElementInfo(LANDING_SELECTORS.LEGAL_SECTION, LANDING_LABEL.LegalSection)
    ].filter(Boolean)
    // Find target element in sections
    const targetSection = sections.find(s => s.selector === targetSelector)
    if (targetSection) {
      return targetSection.bottom
    }
    // Fallback: direct calculation
    const landingComponent = document.querySelector(LANDING_SELECTORS.LANDING_ASSIGNED_COMPONENT) || document.querySelector(LANDING_SELECTORS.LANDING_UNASSIGNED_COMPONENT)
    if (!landingComponent) return fallbackHeight

    const targetElement = landingComponent.querySelector(targetSelector)
    if (!targetElement) return fallbackHeight

    const rect = targetElement.getBoundingClientRect()
    const absoluteTop = window.pageYOffset + rect.top
    return Math.round(absoluteTop + rect.height)
  } catch (error) {
    return fallbackHeight
  }
}
